//export default {
export default {
  MOBILE_NUMBER: /^([0-9]|[٠-٩])+$/,
  PINCODE:/^([0-9]|[٠-٩])+$/
};
